{
  "Müşteriler": "Customers",
  "musteriler": {
    "Müşteriler": "Customers",
    "Ad": "First Name",
    "Soyad": "Last Name",
    "Referans": "Reference",
    "Cep": "Mobile",
    "Cep 2": "Mobile 2",
    "Meslek": "Profession",
    "Cinsiyet": "Gender",
    "Kimlik No": "ID Number",
    "Doğum Tarihi": "Date of Birth",
    "Email": "Email",
    "Email 2": "Email 2",
    "Adres": "Address",
    "İl": "City",
    "İlçe": "District",
    "Not": "Note",
    "Yetki Talep": "Authorization Request",
    "Telefon": "Phone",
    "Onay Bekleyenler": "Pending Approvals",
    "Ara": "Search",
    "Temizle": "Clear",
    "Kapat": "Close",
    "Durum": "Status",
    "Onsekizalti": "Under 18",
    "Sigorta Ettiren": "Policyholder",
    "Yenile": "Refresh"
  }
}
